import { http, HttpResponse } from 'msw';

import { rebalanceFixtures } from '../../fixtures/rebalance.fixtures';

const handlers = [
  http.get('/api/kubernetes/clusters', () => {
    return HttpResponse.json({ items: [] });
  }),
  http.get('/api/kubernetes/clusters/:clusterId', () => {
    return HttpResponse.json({});
  }),
  http.get('/api/v1/kubernetes/clusters/:clusterId/workloads', () => {
    return HttpResponse.json(rebalanceFixtures.workloadsResponse);
  }),
  http.get('/api/v1/kubernetes/clusters/:clusterId/rebalancing-plans', () => {
    return HttpResponse.json([]);
  }),
  http.get(
    '/api/v1/kubernetes/clusters/:clusterId/rebalancing-plans/:rebalancingPlanId',
    () => {
      return HttpResponse.json(rebalanceFixtures.rebalancePlanResponse);
    }
  ),
  http.get('/api/v1/kubernetes/clusters/:clusterId/feedbackevents', () => {
    return HttpResponse.json({});
  }),
  http.get('/api/v1/kubernetes/clusters/:clusterId/health', () => {
    return HttpResponse.json({});
  }),
  http.get('/api/v1/kubernetes/clusters/:clusterId/ingress-controller', () => {
    return HttpResponse.json({});
  }),
  http.get('/api/v1/kubernetes/clusters/:clusterId/kubeconfig', () => {
    return HttpResponse.json({});
  }),
  http.get('/api/v1/kubernetes/clusters/:clusterId/legacy-addons', () => {
    return HttpResponse.json({});
  }),
  http.get('/api/v1/kubernetes/clusters/:clusterId/metrics', () => {
    return HttpResponse.json({});
  }),
  http.get('/api/v1/kubernetes/clusters/:clusterId/nodes', () => {
    return HttpResponse.json({});
  }),
  http.get('/api/v1/kubernetes/clusters/:clusterId/nodes/:nodeId', () => {
    return HttpResponse.json({});
  }),
  http.get('/api/v1/kubernetes/clusters/:clusterId/pause-schedule', () => {
    return HttpResponse.json({});
  }),
];

export default handlers;
